import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load } from '../reducers/vidiprinter';
import FootballVidiprinterPage from '../components/FootballVidiprinterPage';

const REFRESH_INTERVAL_MILLIS = 10000;

@layoutAsyncConnect(
  'FootballVidiprinterPageContainer',
  [{
    dispatch: () => load(),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => {
      let {football: {vidiprinter = {items: []}}} = state;
      return {vidiprinter};
    }
  }]
)
@catchLifeCycleErrors
export default class FootballVidiprinterPageContainer extends Component {
  static propTypes = {
    vidiprinter: PropTypes.object,

    // supplied by redux-react via @connect
    dispatch: PropTypes.func.isRequired
  };

  render() {
    return (
      <FootballVidiprinterPage data={this.props.vidiprinter}/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballVidiprinterPageContainer.js